import React from 'react';
import styled from 'styled-components';

const ReferralContainer = styled.div`
  background-color: #f8f9fa;
  border: 2px solid #7ECBB9;
  border-radius: 12px;
  padding: 1rem;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

const ReferralIcon = styled.div`
  background-color: #7ECBB9;
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  flex-shrink: 0;
`;

const ReferralContent = styled.div`
  flex: 1;
`;

const ReferralLabel = styled.div`
  font-family: 'Nunito', sans-serif;
  font-size: 0.875rem;
  color: #6c757d;
  margin-bottom: 0.25rem;
`;

const ReferralCode = styled.div`
  font-family: 'Quicksand', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  color: #2d3142;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const ReferralCodeDisplay = ({ referralCode }) => {
  if (!referralCode || referralCode === 'direct') {
    return null;
  }

  return (
    <ReferralContainer>
      <ReferralIcon>
        🎯
      </ReferralIcon>
      <ReferralContent>
        <ReferralLabel>Referral Code</ReferralLabel>
        <ReferralCode>{referralCode}</ReferralCode>
      </ReferralContent>
    </ReferralContainer>
  );
};

export default ReferralCodeDisplay;
